import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=728e3d13&scoped=true&"
import script from "./index2.vue?vue&type=script&lang=ts&"
export * from "./index2.vue?vue&type=script&lang=ts&"
import style0 from "./index2.vue?vue&type=style&index=0&id=728e3d13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e3d13",
  null
  
)

export default component.exports